export const PROJECT_URL = "https://bghajclgkhlzqwpooqiw.supabase.co";
export const ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJnaGFqY2xna2hsenF3cG9vcWl3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwMzk0NzUsImV4cCI6MjAyMjYxNTQ3NX0.7VPTgrGTSTUeSMQfNe6DO5jYeOYywy-437oH6-yZia8";
